import { render, staticRenderFns } from "./GymVideoCardNew.vue?vue&type=template&id=1fb71342&scoped=true&"
import script from "./GymVideoCardNew.vue?vue&type=script&lang=js&"
export * from "./GymVideoCardNew.vue?vue&type=script&lang=js&"
import style0 from "./GymVideoCardNew.vue?vue&type=style&index=0&id=1fb71342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb71342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb71342')) {
      api.createRecord('1fb71342', component.options)
    } else {
      api.reload('1fb71342', component.options)
    }
    module.hot.accept("./GymVideoCardNew.vue?vue&type=template&id=1fb71342&scoped=true&", function () {
      api.rerender('1fb71342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Gym/Includes/GymVideoCardNew.vue"
export default component.exports